import { cancelUserOrder, getOrderDetail, getDrawbackList, requestDrawback, checkCanDrawback, refundAmount, checkAllowExchange, getExchangeRecord, getExchangeDetails, submitExchangeOrder, cancelExchangeOrder, getRefundDetails, cancelDrawback, getWechatPayInfo } from '@/api/order/index';

const order = {
  state: {
    productList: [],
    productType: [],
    banners: [],
    activePake: '',
    drawbackItem: {}
  },

  mutations: {
    SET_PRODUCT_LIST: (state, data) => {
      state.productList = data;
    },
    SET_DRAWBACK_ITEM: (state, data) => {
      state.drawbackItem = data;
    }
  },

  actions: {
    // 取消用户订单
    CancelUserOrder({ commit }, data) {
      return new Promise((resolve, reject) => {
        cancelUserOrder(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 获取订单详情
    GetOrderDetail({ commit }, data) {
      return new Promise((resolve, reject) => {
        getOrderDetail(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 获取订单详情
    GetDrawbackList({ commit }, data) {
      return new Promise((resolve, reject) => {
        getDrawbackList(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },

    // 申请退款
    RequestDrawback({ commit }, data) {
      return new Promise((resolve, reject) => {
        requestDrawback(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 检查是否可以退款
    CheckCanDrawback({ commit }, data) {
      return new Promise((resolve, reject) => {
        checkCanDrawback(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 检查是否允许换课
    CheckAllowExchange({ commit }, data) {
      return new Promise((resolve, reject) => {
        checkAllowExchange(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 退款金额
    RefundAmount({ commit }, data) {
      return new Promise((resolve, reject) => {
        refundAmount(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },

    // 保存要退款的 item 信息
    SetDrawbackItem({ commit }, data) {
      console.log('data:', data);
      return new Promise((resolve, reject) => {
        commit('SET_DRAWBACK_ITEM', data);
        resolve();
      });
    },

    // 查看退款详情
    GetRefundDetails({ commit }, data) {
      return new Promise((resolve, reject) => {
        getRefundDetails(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },

    // 取消退款
    CancelDrawback({ commit }, data) {
      return new Promise((resolve, reject) => {
        cancelDrawback(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 换课记录
    GetExchangeRecord({ commit }, data) {
      return new Promise((resolve, reject) => {
        getExchangeRecord(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 换课详情
    GetExchangeDetails({ commit }, data) {
      return new Promise((resolve, reject) => {
        getExchangeDetails(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 提交换课申请
    SubmitExchangeOrder({ commit }, data) {
      return new Promise((resolve, reject) => {
        submitExchangeOrder(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 取消换课申请
    CancelExchangeOrder({ commit }, data) {
      return new Promise((resolve, reject) => {
        cancelExchangeOrder(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 获取微信支付信息
    getWechatPayInfo({ commit }, data) {
      return new Promise((resolve, reject) => {
        getWechatPayInfo(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    }
  }
};

export default order;



// WEBPACK FOOTER //
// ./src/store/order.js